import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";

export const assignEntities = async (
  parentLinkAttributeId: ZUid,
  parentEntityId: ZUid,
  entityIds: ZUid[],
) => {
  await rest.put(apiObjUrl("/assign-entities"), {
    parentLinkAttributeId,
    parentEntityId,
    entityIds,
  });
};
